// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"490cb324","239":"e12abfca","553":"7118e1ea"}[chunkId] + ".chunk.js";
};